import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {GetUserPaymentsParams, getUserPayouts} from '../api';
import {QUERY__USER_PAYOUTS} from '../queryKeys';
import {Transaction} from '../types';

export const useGetUserPayouts = <SelectedData = GetListOutput<Transaction>>(
  params: GetUserPaymentsParams,
  options?: QueryOptionsForList<Transaction, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__USER_PAYOUTS, params],
    queryFn: () => getUserPayouts(params),
    ...options,
  });
};
